import SiafLiteApiRepository from "../../external/siafLiteApi";

class PdvOfflineService {
	constructor() {
		this.urlBase = "/fiscal/pdv-offline";
		this.urlBaseEvent = `/event${this.urlBase}`;
	}

	getAll(filter) {
		return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
	}

	cadastrar(body) {
		return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
	}

	atualizar(id, body) {
		return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
	}
}

export default PdvOfflineService;
